module.exports = __webpack_public_path__ + "img/lihat-mutasi-icon.687ff1e5.svg";